{
  "all-listings": {
    "disconnected": {
      "text": "Create an account or log in to view resources available on Partage Agricole network."
    },
    "needLogin": {
      "secondLine": "Create an account or log in to view resources available on Partage Agricole network."
    },
    "empty": {
      "offer": {
        "firstLine": "Start your adventure here!",
        "primaryButtonText": "Post an offer!",
        "secondLine": "Join the catalog by offering items to lend."
      }
    }
  },
  "common": {
    "appName": "Partage Agricole",
    "appDownloadPrompt": {
      "guest": "Like what you see? Get Partage Agricole on your phone and receive new availability near you",
      "qrCodeAccessibilityLabel": "QR code to download the Partage Agricole app"
    }
  },
  "contact-information": {
    "prompt": "Add your business postal code to see which items are available nearby.",
    "title": "Your address",
    "prompt-public": "Add your postal code to see listings available nearby.",
    "title-public": "Your postal code"
  },
  "contact-us": {
    "firstParagraph": "Partage Agricole member service is available by email and in-app messaging. We will respond to you as quickly as possible.",
    "faqLink": "https://www.partageagricole.ca/faq",
    "chatPrompt": {
      "bugReport": "Hi! 😊\n\nThanks for explaining what's wrong.",
      "suggestion": "Hi! 😊\n\nWe're always open to suggestions. Thank you for helping us improve our service.\n\nThanks!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Only Partage Agricole partners can use this app. To get the invitation code, contact <a>Partage Agricole</a>.",
    "activationCodeFieldHelpLink": "https://www.partageagricole.ca/s-inscrire"
  },
  "guidelines": {
    "fifthParagraph": "Do not use Partage Agricole to sell items."
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Joined Partage Agricole",
        "title": "Explorer"
      }
    }
  },
  "introModal": {
    "title": "Hello {{name}},",
    "first": "Thank you for joining the community and taking your first step toward reducing your consumption and building new connections!",
    "second": "<strong>Sharing is a sign of trust</strong> : the more you lend, the more others will want to lend to you!",
    "third": "<strong>Know that less than 0.1% of all shares</strong> result in damage. And it's not out of bad faith—it's just normal when items get a bit more use."
  },
  "my-information": {
    "firstNameFieldLabel": "Business name",
    "credentialInformationTitle": "Account & security",
    "personalInformationTitle": "Profile information"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Business name",
    "firstNameFieldPlaceholder": "e.g., Ferme de la Tour d'Argent",
    "title": "Profile information"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Your subscription to this sharing app is courtesy of Partage Agricole."
      },
      "title": {
        "enterprise": "Partage Agricole Subscription"
      }
    },
    "noEnd": "This subscription is valid as long as you are a Partage Agricole member."
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "e.g., Garden tractor",
      "descriptionFieldPlaceholder": {
        "offer": "Brand, dimensions, color, weight, condition, year acquired, lending terms, specific features of the item...",
        "request": "Brand, dimensions, color, weight, condition, year acquired, lending terms, specific features of the item..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Welcome to the club",
        "body": "Discover Partage Agricole!"
      }
    },
    "welcome": "Welcome to Partage Agricole!",
    "welcomeMessage": "Thank you for your trust.",
    "rate": {
      "borrower": {
        "message": "Your feedback is important to us and to other members of Partage Agricole."
      },
      "lender": {
        "message": "Your feedback is important to us and to other members of Partage Agricole."
      }
    }
  },
  "offerAvailability": {
    "refrainPopup": {
      "hi": "Dear member,",
      "text": {
        "lender": {
          "before": "Don't forget to book your work dates and plan your transportation days when making your reservation.",
          "after": "Don't forget to book your work dates and plan your transportation days."
        },
        "borrower": "Don't forget to plan your setup and takedown days when borrowing."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "The need has been fulfilled on Partage Agricole"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Business name",
    "firstNameFieldPlaceholder": "e.g., Ferme de la Tour d'Argent",
    "pictureFieldSubtitle": "This image will appear in your listings and your profile.",
    "pictureFieldTitle": "Add a logo image for your business",
    "title": "Profile information",
    "firstNameFieldLabel-public": "First name",
    "firstNameFieldPlaceholder-public": "First name",
    "lastNameFieldLabel-public": "Last name",
    "lastNameFieldPlaceholder-public": "Last name",
    "phoneFieldLabel-public": "Phone number (optional)",
    "pictureFieldSubtitle-public": "The profile picture increases trust between members",
    "pictureFieldTitle-public": "Add a profile picture",
    "title-public": "Your personal information"
  },
  "privacy": {
    "link1": "https://www.partageagricole.ca/termes-et-conditions",
    "link2": "https://www.partage.club/politique-de-confidentialite",
    "line3": "by Partage Agricole."
  },
  "quick-new-thanks": {
    "bodyText": "You’ve just contributed to enriching the <strong>Partage Agricole</strong> catalog! \n\nYou can modify your offers at any time in your sharing center."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contact Partage Agricole"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "By offering your items, you even encourage the shyest farmers to make requests."
      }
    }
  }
}
